export default __webpack_public_path__ + "static/13-7800ef0d9a6a7224124147e367fdebec.jpg";